import Page from '@app/components/layout/page/page';
import { purchasedGoodsRoutes } from '@app/purchased-goods/purchased-goods-routes';
import Text from '@shared/components/content/text';
import { Link, useNavigate } from 'react-router-dom';
import CCFFoodTable from '../../components/scope-3/food/ccf-food-table';
import { reportSlugs } from '../../slugs';
import { useCategory } from '../../utils';
import EmptyCategoryPage from '../ccf-category-intro-page';

export default function CCFFoodAndDrinkPage() {
  const navigate = useNavigate();
  const category = useCategory(reportSlugs.foodAndDrink);

  return (
    <Page name="Scope 3 - Food and drink" page="subpage">
      {category.hasActivityData ? (
        <CCFFoodTable />
      ) : (
        <EmptyCategoryPage
          categorySlug="food"
          description={
            <div className="space-y-4">
              <Text>
                The emissions from the food & drink you purchase fall within
                Scope 3, Category 1 - Purchased Goods & Services. This category
                represents <b>the majority of your Scope 3 emissions</b>, and is
                therefore the only Scope 3 Category that WRAP requires you to
                report in their sector-specific guidance.
              </Text>
              <Text>
                Your food & drink purchases are managed via the{' '}
                <Link
                  to={purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK}
                  className="font-medium text-teal-600"
                >
                  Purchased goods
                </Link>{' '}
                area of our platform, where our AI-powered tool will allow you
                to easily import your data from a spreadsheet. Emissions from
                purchases that fall within this reporting year will appear here
                automatically once you have completed the import.
              </Text>
            </div>
          }
          primaryActionText="Manage imports"
          primaryActionProps={{
            onClick: () =>
              navigate(
                purchasedGoodsRoutes.PURCHASED_GOODS_IMPORTS_LIST +
                  `?activityType=food`
              ),
          }}
        />
      )}
    </Page>
  );
}
